/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N7Inputs */

const en_to_yaml_ref_n7 = /** @type {(inputs: To_Yaml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An empty array stays in flow style, because there is no element to put on a line.`)
};

const ko_to_yaml_ref_n7 = /** @type {(inputs: To_Yaml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 배열은 흐름 스타일로 남습니다. 줄에 올릴 요소가 없기 때문입니다.`)
};

const ja_to_yaml_ref_n7 = /** @type {(inputs: To_Yaml_Ref_N7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空の配列はフロースタイルのまま残ります。行に載せる要素がないからです。`)
};

/**
* | output |
* | --- |
* | "An empty array stays in flow style, because there is no element to put on a line." |
*
* @param {To_Yaml_Ref_N7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n7 = /** @type {((inputs?: To_Yaml_Ref_N7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n7(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n7(inputs)
	return ja_to_yaml_ref_n7(inputs)
});